<script setup lang="ts">
import BaseToast from '@/components/base/BaseToast.vue'
import { useToasts } from '@/core/composables/useToasts'
import { useI18n } from 'vue-i18n'

const { toasts, removeToast, numHiddenToasts } = useToasts()
const { t } = useI18n()
</script>

<template>
  <div class="toast-container">
    <div v-if="numHiddenToasts" class="mb-3 rounded-sm bg-white p-3 shadow-sm">
      {{ t('toasts.pending', numHiddenToasts) }}
    </div>
    <TransitionGroup
      tag="span"
      class="flex flex-col gap-y-3"
      enter-from-class="translate-x-8 opacity-0"
      enter-active-class="transition duration-300 ease-out"
      leave-active-class="transition duration-300 ease-in"
      leave-to-class="translate-x-10 opacity-0"
    >
      <BaseToast
        v-for="toast in toasts"
        :key="toast.id"
        :toast
        @close="removeToast"
      />
    </TransitionGroup>
  </div>
</template>

<style lang="scss" scoped>
@reference '../../styles/main.css';

.toast-container {
  @apply fixed inset-x-4 top-4 z-50 sm:left-auto sm:w-[30rem];
}
</style>
